import React from "react";
import { observer } from "mobx-react";
import styled from "styled-components";

import copyImage from "./images/copy.svg";
import Style from "@client/utils/Style";

const Wrapper = styled.span`
  opacity: 0;
  min-width: 16px;
  height: 16px;
  display: inline-block;
  background: url("${copyImage}") no-repeat;
  background-position-y: 2px;
  transition: all ${Style.animations.swift};
`;

@observer
class CopyButton extends React.Component<any> {
  render() {
    return <Wrapper {...this.props} />;
  }
}

export default CopyButton;
